'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVerticalOptions = exports.getActivityOptionsForVerticalId = exports.loadRadius = exports.filtersChanged = exports.filterChanged = exports.loadResultType = exports.loadTime = exports.loadDate = exports.loadLevel = exports.loadAmenity = exports.loadActivity = exports.loadVerticals = exports.LOAD_RADIUS = exports.EXPAND_RADIUS = exports.FILTERS_CHANGED = exports.FILTER_CHANGED = exports.LOAD_RESULT_TYPE = exports.LOAD_TIME = exports.LOAD_DATE = exports.LOAD_LEVEL = exports.LOAD_AMENITY = exports.LOAD_ACTIVITY = exports.LOAD_VERTICALS = exports.LEVEL_OPTIONS = exports.levelMessages = exports.AMENITY_OPTIONS = exports.amenityMessages = exports.RADIUS_OPTIONS = exports.radiusMessages = exports.ACTIVITY_OPTIONS_BY_VERTICAL = exports.TIME_OPTIONS = exports.TIME_DEFAULT = exports.ALL_VERTICALS_OPTION = exports.BASE_VERTICALS_OPTIONS = exports.DEFAULT_RESULT_TYPE_LOGGED_OUT = exports.DEFAULT_RESULT_TYPE_LOGGED_IN = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _ACTIVITY_OPTIONS_BY_;

exports.doLoadVerticals = doLoadVerticals;
exports.getRadiusByItemId = getRadiusByItemId;
exports.getSelectedRadius = getSelectedRadius;
exports.getInUseRadius = getInUseRadius;
exports.getLocalizedDisplayDistance = getLocalizedDisplayDistance;
exports.doLoadRadius = doLoadRadius;
exports.doAddActivityFilter = doAddActivityFilter;
exports.doLoadActivity = doLoadActivity;
exports.doLoadAmenity = doLoadAmenity;
exports.doLoadLevel = doLoadLevel;
exports.doLoadDate = doLoadDate;
exports.doLoadTime = doLoadTime;
exports.getResultType = getResultType;
exports.doLoadResultType = doLoadResultType;
exports.doResetFiltersFromHash = doResetFiltersFromHash;
exports.watchFilters = watchFilters;

var _effects = require('redux-saga/effects');

var _SearchBox = require('features/Search/SearchBox/SearchBox.saga');

var _reactIntl = require('react-intl');

var _locale = require('redux/modules/locale');

var _user = require('redux/modules/user');

var _deep = require('helpers/deep');

var _distance = require('helpers/distance');

var _selectors = require('redux/saga/selectors');

var _filterSets = require('constants/filter-sets');

var _filters = require('./filters.helpers');

var _Search = require('../Search.reducer');

var _Search2 = require('../Search.helpers');

var _Search3 = require('../Search.constants');

var _SearchBox2 = require('../SearchBox/SearchBox.reducer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doLoadVerticals),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getLocalizedDisplayDistance),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(doLoadRadius),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(doAddActivityFilter),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(doLoadActivity),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(doLoadAmenity),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(doLoadLevel),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(doLoadDate),
    _marked9 = /*#__PURE__*/_regenerator2.default.mark(doLoadTime),
    _marked10 = /*#__PURE__*/_regenerator2.default.mark(getResultType),
    _marked11 = /*#__PURE__*/_regenerator2.default.mark(doLoadResultType),
    _marked12 = /*#__PURE__*/_regenerator2.default.mark(doResetFiltersFromHash),
    _marked13 = /*#__PURE__*/_regenerator2.default.mark(watchFilters);

var addFilter = _filters.searchFilterActions.addFilter,
    setFilterValue = _filters.searchFilterActions.setFilterValue;
var ACTIVITY = _Search3.FILTER_NAMES.ACTIVITY,
    DATE = _Search3.FILTER_NAMES.DATE,
    RADIUS = _Search3.FILTER_NAMES.RADIUS,
    RESULT_TYPE = _Search3.FILTER_NAMES.RESULT_TYPE,
    TIME = _Search3.FILTER_NAMES.TIME,
    VERTICAL = _Search3.FILTER_NAMES.VERTICAL,
    AMENITY = _Search3.FILTER_NAMES.AMENITY,
    LEVEL = _Search3.FILTER_NAMES.LEVEL;
var SCHEDULE = _Search3.RESULT_TYPES.SCHEDULE,
    VENUE = _Search3.RESULT_TYPES.VENUE;
var DEFAULT_RESULT_TYPE_LOGGED_IN = exports.DEFAULT_RESULT_TYPE_LOGGED_IN = SCHEDULE;
var DEFAULT_RESULT_TYPE_LOGGED_OUT = exports.DEFAULT_RESULT_TYPE_LOGGED_OUT = VENUE;

var BASE_VERTICALS_OPTIONS = exports.BASE_VERTICALS_OPTIONS = [(0, _extends4.default)({
  id: _Search3.VERTICALS.fitness
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.vertical.fitness.name', defaultMessage: 'Group Fitness' },
  description: { id: 'filters.vertical.fitness.description', defaultMessage: 'Yoga, boxing, pilates, etc' }
})), (0, _extends4.default)({
  id: _Search3.VERTICALS.wellness
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.vertical.wellness.name', defaultMessage: 'Wellness' },
  description: { id: 'filters.vertical.wellness.description', defaultMessage: 'Massages, meditation, etc.' }
})), (0, _extends4.default)({
  id: _Search3.VERTICALS.gym
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.vertical.gym.name', defaultMessage: 'Gym Time' },
  description: { id: 'filters.vertical.gym.description', defaultMessage: 'Book flexible sessions at the gym' }
}))];
var ALL_VERTICALS_OPTION = exports.ALL_VERTICALS_OPTION = (0, _extends4.default)({
  id: _Search3.VERTICALS.all
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.vertical.all.name', defaultMessage: 'All categories' }
}));

var TIME_DEFAULT = exports.TIME_DEFAULT = '04:30-23:00';
var TIME_OPTIONS = exports.TIME_OPTIONS = [(0, _extends4.default)({
  id: '05:00-08:00'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.time.early.name', defaultMessage: 'Early Morning' },
  description: { id: 'filters.time.early.description', defaultMessage: '5 am - 8 am' }
})), (0, _extends4.default)({
  id: '08:00-10:00'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.time.late-morning.name', defaultMessage: 'Late Morning' },
  description: { id: 'filters.time.late-morning.description', defaultMessage: '8 am - 10 am' }
})), (0, _extends4.default)({
  id: '10:00-14:00'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.time.midday.name', defaultMessage: 'Midday' },
  description: { id: 'filters.time.midday.description', defaultMessage: '10 am - 2 pm' }
})), (0, _extends4.default)({
  id: '14:00-17:00'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.time.afternoon.name', defaultMessage: 'Afternoon' },
  description: { id: 'filters.time.afternoon.description', defaultMessage: '2 pm - 5 pm' }
})), (0, _extends4.default)({
  id: '17:00-19:00'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.time.evening.name', defaultMessage: 'Evening' },
  description: { id: 'filters.time.evening.description', defaultMessage: '5 pm - 7 pm' }
})), (0, _extends4.default)({
  id: '19:00-23:00'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.time.late-evening.name', defaultMessage: 'Late evening' },
  description: { id: 'filters.time.late-evening.description', defaultMessage: 'After 7 pm' }
}))];

var ACTIVITY_OPTIONS_BY_VERTICAL = exports.ACTIVITY_OPTIONS_BY_VERTICAL = (_ACTIVITY_OPTIONS_BY_ = {}, (0, _defineProperty3.default)(_ACTIVITY_OPTIONS_BY_, _Search3.VERTICALS.fitness, [(0, _extends4.default)({
  id: 'activity-1'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.activity.fitness.1.name', defaultMessage: 'Yoga' }
})), (0, _extends4.default)({
  id: 'activity-553'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.activity.fitness.553.name', defaultMessage: 'Barre' }
})), (0, _extends4.default)({
  id: 'activity-95'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.activity.fitness.95.name', defaultMessage: 'Strength training' }
})), (0, _extends4.default)({
  id: 'activity-23'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.activity.fitness.23.name', defaultMessage: 'Martial arts' }
})), (0, _extends4.default)({
  id: 'activity-467'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.activity.fitness.467.name', defaultMessage: 'Rowing' }
})), (0, _extends4.default)({
  id: 'activity-589'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.activity.fitness.589.name', defaultMessage: 'Running' }
})), (0, _extends4.default)({
  id: '869'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.activity.fitness.869.name', defaultMessage: 'Prenatal' }
})), (0, _extends4.default)({
  id: 'activity-72'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.activity.fitness.72.name', defaultMessage: 'Cycling' }
})), (0, _extends4.default)({
  id: 'activity-90'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.activity.fitness.90.name', defaultMessage: 'Pilates' }
})), (0, _extends4.default)({
  id: 'activity-100'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.activity.fitness.100.name', defaultMessage: 'Dance' }
})), (0, _extends4.default)({
  id: 'activity-587'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.activity.fitness.587.name', defaultMessage: 'Boxing' }
})), (0, _extends4.default)({
  id: 'activity-591'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.activity.fitness.591.name', defaultMessage: 'Outdoors' }
})), (0, _extends4.default)({
  id: 'activity-590'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.activity.fitness.590.name', defaultMessage: 'Sports' }
}))]), (0, _defineProperty3.default)(_ACTIVITY_OPTIONS_BY_, _Search3.VERTICALS.wellness, [(0, _extends4.default)({
  id: '1145'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.activity.wellness.1145.name', defaultMessage: 'Massage' }
})), (0, _extends4.default)({
  id: '1147'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.activity.wellness.1147.name', defaultMessage: 'Facial' }
})), (0, _extends4.default)({
  id: '1149'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.activity.wellness.1149.name', defaultMessage: 'Cryotherapy' }
})), (0, _extends4.default)({
  id: '1151'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.activity.wellness.1151.name', defaultMessage: 'Sports recovery' }
})), (0, _extends4.default)({
  id: '1153'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.activity.wellness.1153.name', defaultMessage: 'Sauna' }
})), (0, _extends4.default)({
  id: '1155'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.activity.wellness.1155.name', defaultMessage: 'Meditation' }
})), (0, _extends4.default)({
  id: '1157'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.activity.wellness.1157.name', defaultMessage: 'Acupuncture' }
})), (0, _extends4.default)({
  id: '1159'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.activity.wellness.1159.name', defaultMessage: 'Cupping' }
})), (0, _extends4.default)({
  id: '1161'
}, (0, _reactIntl.defineMessages)({
  name: { id: 'filters.activity.wellness.1161.name', defaultMessage: 'Beauty' }
}))]), _ACTIVITY_OPTIONS_BY_);

var radiusMessages = exports.radiusMessages = (0, _reactIntl.defineMessages)({
  imperial: {
    id: 'filters.radius.imperial',
    defaultMessage: '{radius} {radius, plural, one {mile} other {miles}}'
  },
  half_mile: {
    id: 'filters.radius.half-mile',
    defaultMessage: '1/2 mile'
  },
  metric: {
    id: 'filters.radius.metric',
    defaultMessage: '{radius} km'
  },
  auto: {
    id: 'filters.radius.auto',
    defaultMessage: 'Auto'
  }
});
var RADIUS_OPTIONS = exports.RADIUS_OPTIONS = {
  /* eslint-disable object-curly-newline */
  imperial: [{ id: 1, defineMessage: radiusMessages.half_mile, radius: '1/2', value: 0.8 }, { id: 2, defineMessage: radiusMessages.imperial, radius: '1', value: 1.6 }, { id: 3, defineMessage: radiusMessages.imperial, radius: '5', value: 8 }, { id: 4, defineMessage: radiusMessages.imperial, radius: '10', value: 16.1 }, { id: 5, defineMessage: radiusMessages.imperial, radius: '25', value: 40.2 }],
  metric: [{ id: 6, defineMessage: radiusMessages.metric, radius: '1', value: 1 }, { id: 7, defineMessage: radiusMessages.metric, radius: '2', value: 2 }, { id: 8, defineMessage: radiusMessages.metric, radius: '5', value: 5 }, { id: 9, defineMessage: radiusMessages.metric, radius: '10', value: 10 }, { id: 10, defineMessage: radiusMessages.metric, radius: '20', value: 20 }]
  /* eslint-enable object-curly-newline */
};

var amenityMessages = exports.amenityMessages = (0, _reactIntl.defineMessages)({
  showers: {
    id: 'filters.amenity.shower.name',
    defaultMessage: 'Showers'
  },
  lockers: {
    id: 'filters.amenity.locker.name',
    defaultMessage: 'Lockers'
  },
  parking: {
    id: 'filters.amenity.parking.name',
    defaultMessage: 'Parking'
  }
});
var AMENITY_OPTIONS = exports.AMENITY_OPTIONS = [{
  id: 'shower',
  name: amenityMessages.showers
}, {
  id: 'locker',
  name: amenityMessages.lockers
}, {
  id: 'parking',
  name: amenityMessages.parking
}];

var levelMessages = exports.levelMessages = (0, _reactIntl.defineMessages)({
  open: {
    id: 'filters.level.open',
    defaultMessage: 'Open'
  },
  beginner: {
    id: 'filters.level.beginner',
    defaultMessage: 'Beginner'
  },
  advanced: {
    id: 'filters.level.advanced',
    defaultMessage: 'Advanced'
  }
});
var LEVEL_OPTIONS = exports.LEVEL_OPTIONS = [{
  id: 'level_all',
  name: levelMessages.open
}, {
  id: 'level_beginner',
  name: levelMessages.beginner
}, {
  id: 'level_advanced',
  name: levelMessages.advanced
}];

var LOAD_VERTICALS = exports.LOAD_VERTICALS = 'LOAD_VERTICALS';
var LOAD_ACTIVITY = exports.LOAD_ACTIVITY = 'LOAD_ACTIVITY';
var LOAD_AMENITY = exports.LOAD_AMENITY = 'LOAD_AMENITY';
var LOAD_LEVEL = exports.LOAD_LEVEL = 'LOAD_LEVEL';
var LOAD_DATE = exports.LOAD_DATE = 'LOAD_DATE';
var LOAD_TIME = exports.LOAD_TIME = 'LOAD_TIME';
var LOAD_RESULT_TYPE = exports.LOAD_RESULT_TYPE = 'LOAD_RESULT_TYPE';
var FILTER_CHANGED = exports.FILTER_CHANGED = 'classpass/search/FILTER_CHANGED';
var FILTERS_CHANGED = exports.FILTERS_CHANGED = 'classpass/search/FILTERS_CHANGED';
var EXPAND_RADIUS = exports.EXPAND_RADIUS = 'EXPAND_RADIUS';
var LOAD_RADIUS = exports.LOAD_RADIUS = 'LOAD_RADIUS';

var loadVerticals = exports.loadVerticals = function loadVerticals() {
  return { type: LOAD_VERTICALS };
};
var loadActivity = exports.loadActivity = function loadActivity() {
  return { type: LOAD_ACTIVITY };
};
var loadAmenity = exports.loadAmenity = function loadAmenity() {
  return { type: LOAD_AMENITY };
};
var loadLevel = exports.loadLevel = function loadLevel() {
  return { type: LOAD_LEVEL };
};
var loadDate = exports.loadDate = function loadDate() {
  return { type: LOAD_DATE };
};
var loadTime = exports.loadTime = function loadTime() {
  return { type: LOAD_TIME };
};
var loadResultType = exports.loadResultType = function loadResultType() {
  return { type: LOAD_RESULT_TYPE };
};
var filterChanged = exports.filterChanged = function filterChanged(filter) {
  return { type: FILTER_CHANGED, filter: filter };
};
var filtersChanged = exports.filtersChanged = function filtersChanged(filters) {
  return { type: FILTERS_CHANGED, filters: filters };
};
var loadRadius = exports.loadRadius = function loadRadius() {
  return { type: LOAD_RADIUS };
};

var getActivityOptionsForVerticalId = exports.getActivityOptionsForVerticalId = function getActivityOptionsForVerticalId(verticalId) {
  var _ref;

  return verticalId === _Search3.VERTICALS.all ? (_ref = []).concat.apply(_ref, (0, _toConsumableArray3.default)((0, _values2.default)(ACTIVITY_OPTIONS_BY_VERTICAL))) : ACTIVITY_OPTIONS_BY_VERTICAL[verticalId];
};

var getVerticalOptions = exports.getVerticalOptions = function getVerticalOptions(includeAll) {
  return includeAll ? [ALL_VERTICALS_OPTION].concat(BASE_VERTICALS_OPTIONS) : BASE_VERTICALS_OPTIONS;
};

function doLoadVerticals() {
  var _ref2, vertical, defaultVerticalId, verticalOptions;

  return _regenerator2.default.wrap(function doLoadVerticals$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(_Search2.selectFiltersFromSearchResults);

        case 2:
          _ref2 = _context.sent;
          vertical = _ref2.vertical;
          _context.next = 6;
          return (0, _effects.select)(_filters.getDefaultVerticalId);

        case 6:
          defaultVerticalId = _context.sent;
          verticalOptions = getVerticalOptions(defaultVerticalId === _Search3.VERTICALS.all);
          _context.next = 10;
          return (0, _effects.put)(addFilter(VERTICAL, verticalOptions, undefined, { exclusive: true, value: vertical || defaultVerticalId }));

        case 10:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function getRadiusByItemId(filters, itemId) {
  return (0, _deep.deepExtract)(RADIUS + '.itemsById.' + itemId + '.value', filters);
}

// Returns a radius only if the user selected one
function getSelectedRadius(filters) {
  var selectedRadiusId = (0, _deep.deepExtract)(RADIUS + '.value', filters);
  return getRadiusByItemId(filters, selectedRadiusId);
}

// Returns the user selected radius, if user has not selected a radius returns the location radius
function getInUseRadius(filters) {
  var selectedRadiusId = (0, _deep.deepExtract)(RADIUS + '.value', filters);
  return getRadiusByItemId(filters, selectedRadiusId || _Search3.AUTO_RADIUS_ID);
}

function getLocalizedDisplayDistance(distance) {
  var measurementSystem, usesMetricSystem, localizedDistance;
  return _regenerator2.default.wrap(function getLocalizedDisplayDistance$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.select)(_locale.selectMeasurementSystem);

        case 2:
          measurementSystem = _context2.sent;
          usesMetricSystem = measurementSystem === 'metric';
          localizedDistance = usesMetricSystem ? distance : (0, _distance.distanceInMiles)(distance); // convert to mi

          return _context2.abrupt('return', localizedDistance.toFixed(1));

        case 6:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function doLoadRadius() {
  var _ref3, _ref4, measurementSystem, locationAutoCompleteFromHash, radiusList, radiusListCopy, defaultDistance;

  return _regenerator2.default.wrap(function doLoadRadius$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.all)([(0, _effects.select)(_locale.selectMeasurementSystem), (0, _effects.select)(_Search2.selectLocationAutocompleteFromSearchResults)]);

        case 2:
          _ref3 = _context3.sent;
          _ref4 = (0, _slicedToArray3.default)(_ref3, 2);
          measurementSystem = _ref4[0];
          locationAutoCompleteFromHash = _ref4[1];
          radiusList = RADIUS_OPTIONS[measurementSystem];
          // Need to create a copy of our radius list to avoid mutating our base radius option lists

          radiusListCopy = radiusList.slice(0);
          defaultDistance = {
            imperial: (0, _deep.deepExtract)('calculated_radius_miles', locationAutoCompleteFromHash),
            metric: (0, _deep.deepExtract)('calculated_radius_km', locationAutoCompleteFromHash)
          };

          radiusListCopy.unshift({
            id: _Search3.AUTO_RADIUS_ID,
            name: radiusMessages.auto,
            defineMessage: radiusMessages[measurementSystem],
            value: defaultDistance.metric,
            selectedDisplayValue: defaultDistance[measurementSystem]
          });

          _context3.next = 12;
          return (0, _effects.put)(addFilter(RADIUS, radiusListCopy, undefined, { valueFilter: true, value: _Search3.AUTO_RADIUS_ID }));

        case 12:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function doAddActivityFilter(isSelectedByActivityName) {
  var selectedVertical, activities, filterOptions;
  return _regenerator2.default.wrap(function doAddActivityFilter$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)(_filters.selectSelectedVertical);

        case 2:
          selectedVertical = _context4.sent;
          activities = getActivityOptionsForVerticalId(selectedVertical);
          filterOptions = {
            selected: isSelectedByActivityName
          };
          _context4.next = 7;
          return (0, _effects.put)(addFilter(ACTIVITY, activities, undefined, filterOptions));

        case 7:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function doLoadActivity() {
  var currentKeywordSelectedId, _ref5, tags, isSelectedByActivityName;

  return _regenerator2.default.wrap(function doLoadActivity$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.select)(_SearchBox2.selectSelectedKeywordId);

        case 2:
          currentKeywordSelectedId = _context5.sent;
          _context5.next = 5;
          return (0, _effects.select)(_Search2.selectFiltersFromSearchResults);

        case 5:
          _ref5 = _context5.sent;
          tags = _ref5.tag;

          if (!(!currentKeywordSelectedId && tags && tags.length === 1)) {
            _context5.next = 10;
            break;
          }

          _context5.next = 10;
          return (0, _effects.call)(_SearchBox.setActivityKeyword, tags[0]);

        case 10:
          isSelectedByActivityName = {};
          // If 2 or more tags, we initialize the activity filter with those tags.

          if (tags && tags.length >= 2) {
            isSelectedByActivityName = tags.reduce(function (acc, activity) {
              return (0, _extends4.default)({}, acc, (0, _defineProperty3.default)({}, activity, true));
            }, {});
          }

          _context5.next = 14;
          return (0, _effects.call)(doAddActivityFilter, isSelectedByActivityName);

        case 14:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function doLoadAmenity() {
  var filtersFromHash, amenityKeys, isSelectedByAmenityName, filterOptions;
  return _regenerator2.default.wrap(function doLoadAmenity$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.select)(_Search2.selectFiltersFromSearchResults);

        case 2:
          filtersFromHash = _context6.sent;
          amenityKeys = ['shower', 'locker', 'parking'];
          isSelectedByAmenityName = (0, _filters.initializeMultiSelectFromHash)(amenityKeys, filtersFromHash);
          filterOptions = {
            selected: isSelectedByAmenityName
          };
          _context6.next = 8;
          return (0, _effects.put)(addFilter(AMENITY, AMENITY_OPTIONS, undefined, filterOptions));

        case 8:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function doLoadLevel() {
  var filtersFromHash, levelKeys, isSelectedByLevelName, filterOptions;
  return _regenerator2.default.wrap(function doLoadLevel$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.select)(_Search2.selectFiltersFromSearchResults);

        case 2:
          filtersFromHash = _context7.sent;
          levelKeys = ['level_all', 'level_beginner', 'level_advanced'];
          isSelectedByLevelName = (0, _filters.initializeMultiSelectFromHash)(levelKeys, filtersFromHash);
          filterOptions = {
            selected: isSelectedByLevelName
          };
          _context7.next = 8;
          return (0, _effects.put)(addFilter(LEVEL, LEVEL_OPTIONS, undefined, filterOptions));

        case 8:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function doLoadDate() {
  var _ref6, dateFilter, _ref7, date;

  return _regenerator2.default.wrap(function doLoadDate$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.select)(_filters.selectSearchFilters);

        case 2:
          _ref6 = _context8.sent;
          dateFilter = _ref6.date;

          if (!(dateFilter && dateFilter.value)) {
            _context8.next = 6;
            break;
          }

          return _context8.abrupt('return');

        case 6:
          _context8.next = 8;
          return (0, _effects.select)(_Search2.selectFiltersFromSearchResults);

        case 8:
          _ref7 = _context8.sent;
          date = _ref7.date;
          _context8.next = 12;
          return (0, _effects.put)(addFilter(DATE, [], undefined, { valueFilter: true, value: date }));

        case 12:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function doLoadTime() {
  var _ref8, time, _ref9, ft, tt;

  return _regenerator2.default.wrap(function doLoadTime$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.select)(_filters.selectSearchFilters);

        case 2:
          _ref8 = _context9.sent;
          time = _ref8.time;

          if (!(time && time.value)) {
            _context9.next = 6;
            break;
          }

          return _context9.abrupt('return');

        case 6:
          _context9.next = 8;
          return (0, _effects.select)(_Search2.selectFiltersFromSearchResults);

        case 8:
          _ref9 = _context9.sent;
          ft = _ref9.ft;
          tt = _ref9.tt;
          _context9.next = 13;
          return (0, _effects.put)(addFilter(TIME, TIME_OPTIONS, undefined, { valueFilter: true, value: (ft || tt) && ft + '-' + tt }));

        case 13:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function getResultType() {
  var searchFilters, selectedResultType, isUserLoggedIn, _ref10, resultTypeFromHash;

  return _regenerator2.default.wrap(function getResultType$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.select)(_selectors.filterSetFilters, _filterSets.SEARCH);

        case 2:
          searchFilters = _context10.sent;
          selectedResultType = (0, _deep.deepExtract)(RESULT_TYPE + '.value', searchFilters);
          // If the user selected a result type explicitly, use that

          if (!selectedResultType) {
            _context10.next = 6;
            break;
          }

          return _context10.abrupt('return', selectedResultType);

        case 6:
          _context10.next = 8;
          return (0, _effects.select)(_user.isLoggedIn);

        case 8:
          isUserLoggedIn = _context10.sent;

          if (!isUserLoggedIn) {
            _context10.next = 15;
            break;
          }

          _context10.next = 12;
          return (0, _effects.select)(_Search2.selectFiltersFromSearchResults);

        case 12:
          _ref10 = _context10.sent;
          resultTypeFromHash = _ref10.result_type;
          return _context10.abrupt('return', resultTypeFromHash || DEFAULT_RESULT_TYPE_LOGGED_IN);

        case 15:
          return _context10.abrupt('return', DEFAULT_RESULT_TYPE_LOGGED_OUT);

        case 16:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function doLoadResultType() {
  var resultType;
  return _regenerator2.default.wrap(function doLoadResultType$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.call)(getResultType);

        case 2:
          resultType = _context11.sent;
          _context11.next = 5;
          return (0, _effects.put)(addFilter(RESULT_TYPE, [], undefined, { exclusive: true, value: resultType }));

        case 5:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

function doResetFiltersFromHash() {
  var _ref11, vertical;

  return _regenerator2.default.wrap(function doResetFiltersFromHash$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.put)((0, _Search.setFilteringDisabled)(true));

        case 2:
          _context12.next = 4;
          return (0, _effects.select)(_Search2.selectFiltersFromSearchResults);

        case 4:
          _ref11 = _context12.sent;
          vertical = _ref11.vertical;
          _context12.next = 8;
          return (0, _effects.put)(setFilterValue(VERTICAL, vertical));

        case 8:
          _context12.next = 10;
          return (0, _effects.call)(doLoadResultType);

        case 10:
          _context12.next = 12;
          return (0, _effects.call)(doLoadActivity);

        case 12:
          _context12.next = 14;
          return (0, _effects.call)(doLoadAmenity);

        case 14:
          _context12.next = 16;
          return (0, _effects.call)(doLoadLevel);

        case 16:
          _context12.next = 18;
          return (0, _effects.put)((0, _Search.setFilteringDisabled)(false));

        case 18:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function watchFilters() {
  return _regenerator2.default.wrap(function watchFilters$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.fork)(_effects.takeLatest, LOAD_VERTICALS, doLoadVerticals);

        case 2:
          _context13.next = 4;
          return (0, _effects.fork)(_effects.takeLatest, LOAD_ACTIVITY, doLoadActivity);

        case 4:
          _context13.next = 6;
          return (0, _effects.fork)(_effects.takeLatest, LOAD_AMENITY, doLoadAmenity);

        case 6:
          _context13.next = 8;
          return (0, _effects.fork)(_effects.takeLatest, LOAD_LEVEL, doLoadLevel);

        case 8:
          _context13.next = 10;
          return (0, _effects.fork)(_effects.takeLatest, LOAD_DATE, doLoadDate);

        case 10:
          _context13.next = 12;
          return (0, _effects.fork)(_effects.takeLatest, LOAD_TIME, doLoadTime);

        case 12:
          _context13.next = 14;
          return (0, _effects.fork)(_effects.takeLatest, LOAD_RESULT_TYPE, doLoadResultType);

        case 14:
          _context13.next = 16;
          return (0, _effects.fork)(_effects.takeLatest, (0, _Search.setFiltersFromHash)().type, doResetFiltersFromHash);

        case 16:
          _context13.next = 18;
          return (0, _effects.fork)(_effects.takeLatest, LOAD_RADIUS, doLoadRadius);

        case 18:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}